// extracted by mini-css-extract-plugin
export default {"selectView":"MenuTypeFilter_selectView__LlAdL","selectValue":"MenuTypeFilter_selectValue__TqnlQ"};